import { VARIANT } from '@/constants';
import { ProgressAnime as CommonProgressAnime, type ProgressAnimeProps } from '@monorepo/common';

function ProgressAnime(props: ProgressAnimeProps) {
  return <CommonProgressAnime {...props} variant={VARIANT} />;
}

export default ProgressAnime;
